<template>
  <v-footer color="black">
    <div class="footer-container">
      <v-row justify="space-between" align="center">
        <v-col cols="12" md="3" class="text-center text-md-left">
          <v-img src="@/assets/images/image-footer.png" alt="Zinnes Logo" max-width="350" />
        </v-col>
        <v-col cols="12" md="6">
          <v-row no-gutters class="justify-center">
            <v-col cols="6" class="pr-2">
              <v-list-item-group>
                <v-list-item v-for="(link, index) in menuLeft" :key="index">
                  <v-list-item-content>
                    <v-list-item-title>
                      <router-link :to="link.href" class="footer-link">{{ link.text }}</router-link>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-col>
            <v-col cols="6" class="pl-2">
              <v-list-item-group>
                <v-list-item v-for="(link, index) in menuRight" :key="index">
                  <v-list-item-content>
                    <v-list-item-title>
                      <router-link :to="link.href" class="footer-link">{{ link.text }}</router-link>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="3" class="text-center text-md-right">
          <v-row no-gutters>
            <v-col cols="6" class="pr-2">
              <h3 class="text-h6 mb-3">Contato</h3>
              <p class="contact-info">
                <a href="mailto:suporte.zinnes@gmail.com" class="footer-link">suporte.zinnes@gmail.com</a>
              </p>
              <p class="contact-info">
                CNPJ: 52.230.302/0001-50
              </p>
            </v-col>
            <v-col cols="6" class="pl-2">
              <h3 class="text-h6 mb-3">Redes Sociais</h3>
              <v-btn icon v-for="icon in socialIcons" :key="icon" class="mx-1">
                <v-icon color="#FFF" size="34">{{ icon }}</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-row justify="space-between" align="center" class="mt-4">
        <v-col cols="12" md="6" class="text-center text-md-left">
          <p>© 2025 Zinnes. Todos os direitos reservados.</p>
        </v-col>
      </v-row>
    </div>
  </v-footer>
</template>

<script>
export default {
  name: "FooterComponent",
  data() {
    return {
      menuLeft: [
        { text: "Home", href: "/" },
        { text: "Comunidade", href: "/comunidade" },
        { text: "Publicar", href: "/dashboard/publicar-obra/#/dashboard/publicar-obra" },
      ],
      menuRight: [
        { text: "Política de Privacidade", href: "/politica-de-privacidade" },
        { text: "Termos de Uso", href: "/termos-de-uso" },
        { text: "Ajuda", href: "/ajuda-suporte" },
      ],
      socialIcons: ["mdi-facebook", "mdi-instagram"],
    };
  },
};
</script>

<style scoped>
p {
  color: #ffffff !important;
}

.footer-container {
  width: 100%;
  padding: 20px;
}

.footer-link {
  color: rgb(218, 215, 215) !important;
  text-decoration: none;
  font-size: 14px;
  text-align: right;
}

.footer-link:hover {
  text-decoration: underline;
}

.contact-info {
  font-size: 14px !important;
  margin-bottom: 10px !important;
  line-height: 1.4;
  text-align: right;
}

.v-footer {
  width: 100% !important;
  background-color: #631b8d !important;
  background-image: url('@/assets/images/footer-img.png'); /* Caminho da sua imagem */
  background-size: cover; /* Para cobrir toda a área do footer */
  background-position: center; /* Centraliza a imagem */
  color: #ffffff;
}


.v-icon {
  color: white;
}

.v-list-item {
  padding-top: 0;
  padding-bottom: 0;
  min-height: 0
}
</style>
